import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 376FB5C9-DF1A-455B-9824-5D0A3CE61481
 * name clipboard-off
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-off.svg
 * tags
 */
export const ClipboardOffIcon = createSvgIcon(<><path d="M21 5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H6.2L21 17.8V5M12 5C11.45 5 11 4.55 11 4S11.45 3 12 3 13 3.45 13 4 12.55 5 12 5M22.11 21.46L20.84 22.73L19.1 21C19.07 21 19.03 21 19 21H5C3.9 21 3 20.11 3 19V5C3 4.97 3 4.93 3 4.9L1.11 3L2.39 1.73L22.11 21.46Z" /></>, 'ClipboardOffIcon');
export default ClipboardOffIcon